import React from 'react'
import { ImportsReadModel } from '../../model/imports.state.types'
import { FaIcon, faTriangleExclamationRegular } from '@/lib/fa'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import { Button } from '@/ui'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { ImportErrorsAccordion } from '../ImportErrorsAccordion'

type Props = {
  uploadDetails: ImportsReadModel
  handleSubmit: () => void
  handleClose: () => void
}

export function PopupStepSimpleImportSummary(props: Props) {
  const { t } = useLocalize()
  const savedFileNames = new Set(
    Object.values(props.uploadDetails.filesById)
      .filter((f) => (f.validLines ?? 0) > 0)
      .map((f) => f.fileName),
  )
  const savedAnyRows = savedFileNames.size > 0

  return (
    <div className="tw-flex tw-h-fit tw-max-h-[80vh] tw-flex-col">
      <div className="tw-jusitfy-start tw-border-border-base tw-flex tw-w-full tw-flex-col tw-gap-2 tw-border-b tw-pb-4">
        <div className="tw-flex tw-items-center tw-gap-2">
          <FaIcon
            icon={savedAnyRows ? faCircleCheck : faTriangleExclamationRegular}
            className={`tw-h-5 tw-w-5 ${savedAnyRows ? 'tw-text-success' : 'tw-text-warning'}`}
          />
          <h3 className="tw-text-lg tw-font-medium tw-text-content-base">
            {savedAnyRows
              ? t('importModule.imported-files-count').replace('{0}', String(savedFileNames.size))
              : t('importModule.no-data-imported')}
          </h3>
        </div>
      </div>
      <div className="tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-py-4">
        <ImportErrorsAccordion
          filesById={props.uploadDetails.filesById}
          customLogs={props.uploadDetails.customLogs}
          defaultCollapsed={false}
        />
      </div>
      <div className="tw-border-border-base tw-flex tw-justify-end tw-border-t tw-pt-4">
        <Button
          className="tw-h-[38px] tw-w-[102px]"
          text="OK"
          onClick={savedAnyRows ? props.handleSubmit : props.handleClose}
        />
      </div>
    </div>
  )
}
